import { Component, Input, Output, EventEmitter, forwardRef, ElementRef, OnInit } from '@angular/core';
import { AnswerDTO } from 'src/app/model/answerDTO.model';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MediaTypeOption, MediaRatioOption, AnimationOption } from 'library-explorer';

@Component({
    selector: 'app-question-select',
    templateUrl: './question-select.component.html',
    styleUrls: ['./question-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionSelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuestionSelectComponent implements ControlValueAccessor, OnInit {
  @Input() animation: AnimationOption = AnimationOption.NONE;
  @Input() animationDelay: number = 0;
  @Input() answers: AnswerDTO[] = [];
  @Output() selectAnswer: EventEmitter<number> = new EventEmitter();

  @Input() public isTwoColumn = false;

  @Input() mediaType: MediaTypeOption;
  @Input() mediaRatio: MediaRatioOption;

  @Input() disabled = false;
  @Input() multichoice = false;

  public selectedHash: string[] = [];
  public correctAnswersCount = 0;

  onChange = (data: any) => {};
  onTouched = () => {};

  constructor(private readonly element: ElementRef,) { }

  ngOnInit(): void {
    this.setGridConfiguration();
  
    const correctCount = this.answers.filter(a => a.correctAnswer).length;
    this.correctAnswersCount = correctCount || (this.multichoice ? 2 : 1);
  }

  public select(hash: string): void {
    if (this.multichoice) {
      const index = this.selectedHash.indexOf(hash);

      if (index === -1) {
        this.selectedHash.push(hash);
      } else {
        this.selectedHash.splice(index, 1);
      }

      this.emitValue();
      return;
    }

    this.selectedHash = [hash];
    this.emitValue();
  }

  public writeValue(obj: any): void { }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  private emitValue(): void {
    const value = this.selectedHash && this.selectedHash.length 
      ? { answersHash: this.selectedHash}
      : null;

    this.onChange(value);
  }

  private setGridConfiguration(): void {
    let optionSize = 2;
    const rowSize = this.isTwoColumn ? 2 : 4;

    if (this.mediaType === MediaTypeOption.IMAGE || this.mediaType === MediaTypeOption.VIDEO) {
      optionSize = this.mediaRatio === MediaRatioOption.HORIZONTAL ? 2 : 1;
    }

    this.element.nativeElement.style.setProperty('--lms-question-options-rows', rowSize / optionSize);

    this.element.nativeElement.style.setProperty('--lms-question-options-rows-mobile', Math.max(rowSize / (2 * optionSize), 1));
  }

}
